import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/3.jpg")